var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn waves-effect",class:_vm.params.class,attrs:{"disabled":_vm.params.disabled},on:{"click":_vm.onClick}},[(_vm.image)?[_c('icon',{attrs:{"icon-name":_vm.image}})]:_vm._e(),_vm._v(_vm._s(_vm.params.label))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }